export class PreferredInfo {
    PREFERRED_PHONE_NUMBER_ID: number;
    PHONE_NUMBER: string;
    PHONE_NUMBER_VALID: boolean;
    PREFERRED_EMAIL_ID: number;
    EMAIL_ADDRESS: string;
    EMAIL_ADDRESS_VALID: boolean;
}
